export const MessageList = {
  ContinueGoogleMapMarkersFlowMessage: 'ContinueGoogleMapMarkersFlowMessage',
  ContinueJourneyOnFailedFlow: 'ContinueJourneyOnNoRepairerFound',
  ContinueJourneyOnNoRepairerSelected: 'ContinueJourneyOnNoRepairerSelected',
};
